import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { MenuComponent } from '@emm/menu/components/menu/menu.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmMenuDeactivateGuard  {
    canDeactivate(
        component: MenuComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component.checkIfItemHasChanges(component.prevNode).pipe(take(1));
    }
}
